module.exports = __webpack_public_path__ + "img/magnets.2d581fab.jpg";